module.exports = __webpack_public_path__ + "img/20191209_111640-1.24c3e81a.jpg";